var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 14,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C25 39.0417 25 33.5626 28.0265 29.8748C28.5806 29.1996 29.1996 28.5806 29.8748 28.0265C33.5626 25 39.0417 25 50 25C60.9583 25 66.4373 25 70.1253 28.0265C70.8003 28.5806 71.4193 29.1996 71.9733 29.8748C75 33.5626 75 39.0417 75 50C75 60.9583 75 66.4373 71.9733 70.1253C71.4193 70.8003 70.8003 71.4193 70.1253 71.9733C66.4373 75 60.9583 75 50 75C39.0417 75 33.5626 75 29.8748 71.9733C29.1996 71.4193 28.5806 70.8003 28.0265 70.1253C25 66.4373 25 60.9583 25 50Z",
    stroke: "#141B34",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 83.334H60",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16.666H60",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2947 41.1046C44.4234 39.2769 47.154 40.0135 48.7944 41.1867C49.467 41.6677 49.803 41.9083 50.001 41.9083C50.199 41.9083 50.535 41.6677 51.2077 41.1867C52.848 40.0135 55.5787 39.2769 58.7074 41.1046C62.8134 43.5033 63.7424 51.4167 54.2717 58.0927C52.4677 59.3643 51.5657 60 50.001 60C48.4364 60 47.5344 59.3643 45.7304 58.0927C36.2597 51.4167 37.1888 43.5033 41.2947 41.1046Z",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartwatch);
export default __webpack_public_path__ + "static/media/smartwatch.6ff10d2dae42a3ff9bc9c3b7384ccb27.svg";
export { ForwardRef as ReactComponent };